import { formatCurrencyAmount } from "./currencyPrecision";

function normalizedCode(value) {
  return String(value || "").trim().toUpperCase();
}

export function convertReservationBaseAmount({
  baseAmount,
  snapshot,
  targetCurrency,
  convertFromBase,
}) {
  const numeric = Number(baseAmount);
  if (!Number.isFinite(numeric)) return null;

  const target = normalizedCode(targetCurrency);
  const base = normalizedCode(snapshot?.base_currency_code);
  const original = normalizedCode(snapshot?.original_currency_code);
  const lockedRate = Number(snapshot?.applied_rate);

  if (snapshot && target && target === base) return numeric;
  if (snapshot && target && target === original && Number.isFinite(lockedRate) && lockedRate > 0) {
    return numeric / lockedRate;
  }

  const converted = typeof convertFromBase === "function" ? convertFromBase(numeric) : numeric;
  return Number.isFinite(Number(converted)) ? Number(converted) : numeric;
}

export function reservationBaseCentsToCurrencyCents(options) {
  // `cents` is the historical fixed-2 storage scale used by payment APIs. It
  // deliberately remains x100 even when the display currency has 0 minor units.
  const converted = convertReservationBaseAmount({
    ...options,
    baseAmount: Number(options?.baseCents || 0) / 100,
  });
  return Math.round(Number(converted || 0) * 100);
}

export function formatReservationBaseAmount(options) {
  const amount = convertReservationBaseAmount(options);
  if (amount == null) return "—";
  const currency = normalizedCode(options?.targetCurrency) || "EUR";
  return formatCurrencyAmount(amount, currency, {
    locale: options?.locale,
    catalog: options?.currencyCatalog,
    minorUnits: options?.minorUnits,
  });
}
